"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CSCallForwardingWrapperComponent = void 0;
const features_services_1 = require("../../../features/services/features.services");
const constants_1 = require("../../constants");
const generic_content_service_1 = require("../../services/generic-content.service");
class CSCallForwardingWrapperComponent {
    constructor(featuresService, genericContentServiceV2) {
        this.featuresService = featuresService;
        this.genericContentServiceV2 = genericContentServiceV2;
        this.BLOCK_INTL_ROAM = 'BLOCK_INTL_ROAM';
        this.hideCallForwarding = true;
        this.disableCallForwardingComponent = constants_1.disableCallForwardingComponent;
    }
    ngOnInit() {
        this.getGenericContent();
        if (!constants_1.disableCallForwardingComponent) {
            this.loader = true;
            this.featuresService.getFeatures()
                .subscribe((res) => {
                this.hideCallForwarding = this.checkAnySubsHasBlockIntRoamingFeature(res.featureDetail);
                this.loader = false;
            }, (err) => {
                this.error = err;
                this.loader = false;
            });
        }
    }
    checkAnySubsHasBlockIntRoamingFeature(subs) {
        if (subs && subs.length > 0) {
            for (const sub of subs) {
                if ((sub === null || sub === void 0 ? void 0 : sub.activeFeatureList) && (sub === null || sub === void 0 ? void 0 : sub.activeFeatureList.length) > 0) {
                    for (const fn of sub.activeFeatureList) {
                        if (fn.featureServiceName === this.BLOCK_INTL_ROAM) {
                            return true;
                        }
                    }
                }
            }
        }
        return false;
    }
    getGenericContent() {
        const genericContentIds = [
            'genericCallForwardingAlternativeMessage'
        ];
        this.genericContentServiceV2.getBulkGenericContent(genericContentIds).subscribe((bulkGenericContent) => {
            this.genericContentItem = bulkGenericContent;
            for (const genericContent of bulkGenericContent) {
                switch (genericContent.id) {
                    case 'genericCallForwardingAlternativeMessage':
                        this.genericCallForwardingAlternativeMessage = genericContent.content;
                        break;
                    default:
                        break;
                }
            }
        }, (error) => { });
    }
}
exports.CSCallForwardingWrapperComponent = CSCallForwardingWrapperComponent;
//# sourceMappingURL=callforwarding-wrapper.component.js.map